<div class="d-flex flex-column">
  <div class="login-top-bar d-flex flex-row justify-content-between align-items-center">
      <div class="logo-container pointer">
          <a href="https://knowledgehook.com" [khA11yLabel]="'A11Y_LABEL.KNOWLEDGEHOOK_HOME' | translate">
              <kh-logo class="logo"></kh-logo>
          </a>
      </div>
      <div>
        <ng-container *ngIf="showLanguageSelector">
          <kh-dropdown-menu [alignmentRight]="true" class="ml-xs" *ngIf="availableLocales$ | async as availableLocales">
            <div class="language-picker text-center pointer" header>
              <svg class="global-icon">
                <use href="images/global.svg#Layer_1"></use>
              </svg>

              <span class="pl-kh-1 align-middle language-picker-text">{{localeCode | uppercase }}</span>
            </div>
            <kh-dropdown-menu-item *ngFor="let locale of availableLocales" role="menuitem" (click)="setLanguage(locale.LocaleId)">
              <div>{{locale.Language}}</div>
            </kh-dropdown-menu-item>
          </kh-dropdown-menu>
        </ng-container>
       


          <a class="pl-kh-3 kh-medium-title-text signup pointer desktop"
             khA11yClickable
             (click)="navigateStudentLogin()"
             *ngIf="showStudentLogin">
              {{ 'LOGIN_TOP_BAR.STUDENT_LOGIN' | translate }}
          </a>
          <a class="pl-kh-3 kh-medium-title-text signup pointer"
             khA11yClickable
             [routerLink]="loginRoute"
             *ngIf="showLogin">
              {{ 'LOGIN_TOP_BAR.LOGIN' | translate }}
          </a>
          <a class="pl-kh-3 kh-medium-title-text signup pointer"
             khA11yClickable
             (click)="navigateSignUp()"
             [routerLink]="registerRoute"
             *ngIf="showSignup"
             data-testid="sign-up-button">
              {{ 'LOGIN_TOP_BAR.SIGN_UP' | translate }}
          </a>
      </div>
  </div>
  <div class="divider"></div>

  <div class="back-button-container mt-kh-4" *ngIf="!hideBack">
    <kh-back-button (clickEvent)="backButton()"></kh-back-button>
  </div>
</div>
